export default [
    {
        component: () => import(/* webpackChunkName: 'acolhimento-saude-bucal' */ '@/views/ambulatorio/acolhimento-saude-bucal/Index'),
        path: 'acolhimento-saude-bucal',
        redirect: 'acolhimento-saude-bucal/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'acolhimento-saude-bucal' */'@/views/ambulatorio/acolhimento-saude-bucal/List.vue'),
                name: 'acolhimento-saude-bucal-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'acolhimento-saude-bucal' */ '@/views/ambulatorio/acolhimento-saude-bucal/Form.vue'),
                name: 'acolhimento-saude-bucal-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]